export { default } from './CanaisAtendimentoGolpes';
